import { render, staticRenderFns } from "./CasualTextareaInput.vue?vue&type=template&id=60df0d70&"
import script from "./CasualTextareaInput.vue?vue&type=script&lang=js&"
export * from "./CasualTextareaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports